import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityDE extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Erklärung zur Barrierefreiheit - CamAPS FX</title>
                    <meta name="title" content="Erklärung zur Barrierefreiheit"/>
                    <meta name="description"
                          content="CamDiab verpflichtet sich, die Barrierefreiheit und Benutzerfreundlichkeit seiner digitalen Produkte für alle Menschen, einschließlich Menschen mit Behinderunge"/>
                    <meta property="og:locale" content="de"/>
                    <meta name="keywords" content="erklärung zur barrierefreiheit"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Erklärung zur Barrierefreiheit</h1>
                                <h3>Version vom 11. September 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab verpflichtet sich, die Barrierefreiheit und Benutzerfreundlichkeit seiner digitalen Produkte für alle Menschen, einschließlich Menschen mit Behinderungen, zu fördern und zu verbessern.
                                </p>
                                <h2>
                                    Konformitätsstatus
                                </h2>
                                <p>
                                    CamDiab strebt die Einhaltung der Richtlinien für barrierefreie Webinhalte (WCAG) Version 2.2, Konformitätsstufe AA (WCAG 2.2 AA), an. Diese weltweit anerkannten Richtlinien tragen dazu bei, Webinhalte für alle Menschen zugänglicher zu machen.
                                </p>
                                <h2>
                                    Zusätzliche Maßnahmen zur Unterstützung der Barrierefreiheit
                                </h2>
                                <p>
                                    CamDiab ergreift unter anderem die folgenden zusätzlichen Maßnahmen, um die Nutzung unserer digitalen Inhalte zu erleichtern:
                                </p>
                                <ul>
                                    <li>Kontinuierliche Schulungen zur Barrierefreiheit für unsere Mitarbeitenden anbieten</li>
                                    <li>Formelle Qualitätssicherungsmethoden für Barrierefreiheit mithilfe von Bewertungen durch Dritte einsetzen</li>
                                    <li>Klare Ziele und Verantwortlichkeiten für Barrierefreiheit festlegen</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Wir freuen uns über Hinweise dazu, wie wir unsere digitalen Produkte für Nutzerinnen und Nutzer mit Behinderungen verbessern können. Wenn Sie Schwierigkeiten haben, unsere Inhalte anzusehen oder darin zu navigieren, oder wenn Sie Inhalte, Funktionen oder Funktionalitäten bemerken, die Ihrer Meinung nach für Menschen mit Behinderungen nicht vollständig zugänglich sind, kontaktieren Sie uns bitte über unsere Support-E-Mail-Adresse: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Wir nehmen Ihr Feedback ernst und werden es berücksichtigen, wenn wir Möglichkeiten prüfen, den Bedürfnissen aller unserer Kundinnen und Kunden gerecht zu werden und unsere allgemeinen Richtlinien zur Barrierefreiheit weiterzuentwickeln. Auch wenn wir keine Kontrolle über Inhalte haben, die von Drittanbietern bereitgestellt werden, fordern wir diese nachdrücklich dazu auf, zugängliche und benutzerfreundliche Inhalte bereitzustellen.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
